import { useParams } from "react-router-dom"

import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { RoadsideGrading } from "../../containers/RoadsideGrading"

import * as Styled from "./RoadsideSidebarComponents.styled"

type RoadsideSidebarComponentsProps = {
    handleChangeTypeFilter?: (filter: { type: string }) => void,
}

export function RoadsideSidebarComponents(props: RoadsideSidebarComponentsProps) {

    const {
        handleChangeTypeFilter,
    } = props

    const isMobile = useIsMobileDevice()
    const { code, road } = useParams()

    return <Styled.Container isMobile={isMobile}>
        {road && <Styled.RoadDetailInfo isMobile={isMobile} road={road} />}
        <RoadsideGrading isMobile={isMobile} />
        <Styled.RoadsideTypeList
            baseRoadsideTypeCode={code}
            isMobile={isMobile}
            onChangeFilter={handleChangeTypeFilter}
        />
    </Styled.Container>
}